/** Editable starting text, not hidden instructions or a second design schema. */
export const CONCEPT_EXAMPLE = `Pilot a small moon lander from the launch point to a landing pad. Balance gentle thrust against gravity and avoid the rocks.

PLAYERS
One player.

CONTROLS
Landscape. Left and right arrows steer; the up arrow fires the thruster. On a phone, use large left, right and thrust buttons.

RULES
Thrust uses fuel. Land slowly and upright on the pad. A crash costs one of three lives. Each landing gets a little harder.

WINNING
100 points per safe landing, plus one per unit of fuel left. Win after three landings; lose when all lives are gone.

LOOK AND SOUND
Soft retro pixel art: a silver lander, a clearly marked pad and a dark moon landscape. Engine hum while thrusting, a chime on landing.`;
